import React from 'react';
import {Button, Col, Form, Input, Modal, Row} from 'antd';
import Colors from "../../../styles/Colors";
import {BiCheck, BiX} from "react-icons/bi";
import toast, {Toaster} from 'react-hot-toast';
import LlocTreball from "../../../model/root/LlocTreball";


interface Props {
    element: LlocTreball;
    visible: boolean;
    onClose: (llocTreball: LlocTreball, guardar: boolean) => void;
}

const LlocDeTreballModal: React.FC<Props> = ({
                                                 element,
                                                 visible,
                                                 onClose,
                                             }) => {

    const [form] = Form.useForm();
    const format = 'HH:mm';
    const handleSubmit = () => {
        const formData = form.getFieldsValue();
        if (formData.entrada !== null && formData.sortida !== null) {
            const llocTreball = new LlocTreball(formData.id, formData.id, formData.nom, formData.latitud,
                formData.longitud);
            onClose(llocTreball, true);
        } else {
            toast('Falten dades.');
        }

    };

    const filterOption = (input: string, option?: { label: string; value: string }) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

    const handleCancel = () => {
        onClose(new LlocTreball(), false);
    };

    return (
        <>
            <Toaster/>
            <Modal
                title="Editar Control Horari"
                open={visible}
                onCancel={handleCancel}
                footer={[
                    <>
                        <Button title={"Acceptar"} style={{backgroundColor: Colors.colors.color6}}
                                onClick={handleSubmit}><BiCheck/></Button>
                        {" "}
                        <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                                onClick={handleCancel}><BiX/></Button>
                    </>
                ]}
                width={300}
            >
                <Form form={form} initialValues={element}>
                    <Row gutter={[16, 16]}>
                        <Col span={42}>
                            <Form.Item label="ID" name="id">
                                <Input disabled/>
                            </Form.Item>
                            <Form.Item label="Nom" name="nom" required>
                                <Input type={"text"}/>
                            </Form.Item>
                            <Form.Item label="Latitud" name="latitud" required>
                                <Input type={"text"}/>
                            </Form.Item>
                            <Form.Item label="Longitud" name="longitud" required>
                                <Input type={"text"}/>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </>
    );
};

export default LlocDeTreballModal;
